<template>
  <div>
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Divider orientation="left">其他材料</Divider>
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="补充说明">
          <Input disabled v-model="form.supplementaryMaterialDescription" :rows="4" placeholder="请输入..." type="textarea" />
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem :label="'其他材料'">
          <!-- <Upload :show-upload-list="false" :default-file-list="form.supplementaryMaterialOtherFileGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `supplementaryMaterialOtherFileGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `supplementaryMaterialOtherFileGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline">上传文件</Button>
              </Upload> -->
          <div class="_link" v-for="item in form.supplementaryMaterialOtherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.supplementaryMaterialOtherFileGuidListPreview.length<1">无</span>
        </FormItem>
        </Col>
      </Row>
    </Form>

  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},

      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
    }
  },
  methods: {
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
  },
}
</script>